<div class="modal-header">
  <h4 class="modal-title pull-left">FRT Accessorials</h4>
  <button type="button"  class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="row">
      <div class="row" *ngIf="showExport">
        <div style="padding-bottom: 4px; float: right !important;">
          <label style="margin-left: 20px;"> <button type="button" (click)="onBtExport()">Export to CSV</button> </label>
        </div>
      </div>
      <div class="col-md-12">
        <ag-grid-angular
          class="ag-theme-alpine"
          id="myGrid"
          [columnDefs]="columnDefsAcc"
          [defaultColDef]="defaultColDef"
          [components]="components"
          [gridOptions]="gridOptions"
          [rowSelection]="rowSelection"
          [suppressDragLeaveHidesColumns]="true"
          [domLayout]="domLayout"
          [overlayNoRowsTemplate] = "overlayNoRowsTemplate"
          [overlayLoadingTemplate]="overlayLoadingTemplate"
          (gridReady)="onGridReady($event)"
        ></ag-grid-angular>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button"  class="btn btn-primary" (click)="closeModal()">Close</button>
  <!--<button type="button"  class="btn btn-primary" (click)="saveAcc()">Save</button>-->
</div>

